"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CheckmarkIcon = void 0;
const react_1 = require("react");
const React = require("react");
const icon_1 = require("./icon");
class CheckmarkIcon extends react_1.Component {
    render() {
        const { fill = icon_1.ICON_COLORS.fill } = this.props;
        return (React.createElement("svg", { width: "24px", height: "24px", viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink" },
            React.createElement("g", { stroke: "none", strokeWidth: "1", fill: fill, fillRule: "evenodd" },
                React.createElement("g", { fill: fill },
                    React.createElement("path", { d: "M21.0532446,7.70216306 C21.0532446,7.4109817 20.936772,7.11980033 20.7271215,6.91014975 L19.1430948,5.32612313 C18.9334443,5.11647255 18.6422629,5 18.3510815,5 C18.0599002,5 17.7687188,5.11647255 17.5590682,5.32612313 L9.91846922,12.9783694 L6.49417637,9.54242928 C6.28452579,9.3327787 5.99334443,9.21630616 5.70216306,9.21630616 C5.4109817,9.21630616 5.11980033,9.3327787 4.91014975,9.54242928 L3.32612313,11.1264559 C3.11647255,11.3361065 3,11.6272879 3,11.9184692 C3,12.2096506 3.11647255,12.5008319 3.32612313,12.7104825 L7.54242928,16.9267887 L9.12645591,18.5108153 C9.33610649,18.7204659 9.62728785,18.8369384 9.91846922,18.8369384 C10.2096506,18.8369384 10.5008319,18.7204659 10.7104825,18.5108153 L12.2945092,16.9267887 L20.7271215,8.49417637 C20.936772,8.28452579 21.0532446,7.99334443 21.0532446,7.70216306 L21.0532446,7.70216306 Z" })))));
    }
}
exports.CheckmarkIcon = CheckmarkIcon;



//////////////////
// WEBPACK FOOTER
// ./src/client/components/icons/checkmark.tsx
// module id = 2132
// module chunks = 0 1 2